import React from "react";

const LandingPage = ({ onShowAuth }) => {
  return (
    <div className="w-full max-w-md border-2 border-red-900 bg-red-900/10 p-10 text-center mx-4">
      <h1 className="text-5xl font-black text-red-600 mb-2 tracking-tighter italic uppercase">
        Trap Tycoon
      </h1>
      <p className="text-red-900 text-[10px] font-black tracking-[0.4em] mb-12 uppercase">
        Global Underground Operations
      </p>

      <div className="space-y-4">
        <button
          onClick={onShowAuth}
          className="w-full border-2 border-red-600 bg-red-600 text-black py-4 font-black hover:bg-transparent hover:text-red-600 transition-all uppercase tracking-widest text-lg"
        >
          Enter the Trap
        </button>

        <a
          href="https://store.steampowered.com/app/4391080/Trap_Tycoon/"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full border-2 border-zinc-800 bg-zinc-900 text-zinc-500 py-4 font-black hover:border-white hover:text-white transition-all uppercase tracking-widest text-sm"
        >
          View on Steam
        </a>
      </div>

      <div className="mt-12 pt-6 border-t border-red-900/20">
        <p className="text-[9px] text-red-900 font-bold uppercase tracking-widest">
          Unauthorized access is strictly prohibited
        </p>
      </div>
    </div>
  );
};

export default LandingPage;
